import { render, staticRenderFns } from "./ReportingCard.vue?vue&type=template&id=19b6f6b4&scoped=true"
import script from "./ReportingCard.vue?vue&type=script&lang=js"
export * from "./ReportingCard.vue?vue&type=script&lang=js"
import style0 from "./ReportingCard.vue?vue&type=style&index=0&id=19b6f6b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b6f6b4",
  null
  
)

export default component.exports